import INFTCollections from '../../models/INFTCollections'
import GeneralCard from '../../nftFormats/Generals/Card/GeneralCard'
import GeneralActivityDetail from '../../nftFormats/Generals/Activity/GeneralActivityDetail'
import TubbyReindeerLogo from '../../../../assets/nft-logo/TubbyReindeer.jpg'
import TubbyReindeerDetail from '../../nftFormats/TubbyReindeer/Detail/TubbyReindeerDetail'

export const TubbyReindeerData: INFTCollections[] = [
  {
    id: 'TubbyReindeer',
    tokenAddress: '0xa5a0958aac97c89406ae14666a42eef91d8801d4',
    name: 'Tubby Reindeer',
    cardFormat: GeneralCard,
    detailFormat: TubbyReindeerDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    creatorAddress: '0x4301480bE8D0C72311B32bd16CFC129714Fe52B5',
    logo: TubbyReindeerLogo,
    website: 'https://tubbyreindeer.com/',
    twitter: 'Tubby_Reindeer',
    telegram: 'https://t.me/Tubby_Reindeer',
    discord: 'https://discord.com/invite/vyfPpRVqmm'
  }
]

export const TubbyReindeerCategoryData = {
  [TubbyReindeerData[0].tokenAddress.toLowerCase()]: TubbyReindeerData[0].category
}

export enum TraitTypes {
  BACKGROUND = 'Background',
  SKIN = 'Skin',
  FACE = 'Face',
  CLOTHES = 'Clothes',
  HATS = 'Hats'
}

export enum RarityType {
  COMMON = 'Common',
  RARE = 'Rare',
  SUPER_RARE = 'Super Rare',
  LEGENDARY = 'Legendary'
}

export enum RarityColor {
  COMMON = '#CF9155',
  RARE = '#C1AF1D',
  SUPER_RARE = '#BA1D21',
  LEGENDARY = '#208AAD'
}

const TraitTypeAndColor = {
  COMMON: {
    rarityType: RarityType.COMMON,
    color: RarityColor.COMMON
  },
  RARE: {
    rarityType: RarityType.RARE,
    color: RarityColor.RARE
  },
  SUPER_RARE: {
    rarityType: RarityType.SUPER_RARE,
    color: RarityColor.SUPER_RARE
  },
  LEGENDARY: {
    rarityType: RarityType.LEGENDARY,
    color: RarityColor.LEGENDARY
  }
}

const SameTraitProps = {
  CommonBackgrounds: {
    traitType: TraitTypes.BACKGROUND,
    percent: '10',
    ...TraitTypeAndColor.COMMON
  },
  RareBackgrounds: {
    traitType: TraitTypes.BACKGROUND,
    percent: '6',
    ...TraitTypeAndColor.RARE
  },
  SuperRareBackgrounds: {
    traitType: TraitTypes.BACKGROUND,
    percent: '2.4',
    ...TraitTypeAndColor.SUPER_RARE
  },
  LegendaryBackgrounds: {
    traitType: TraitTypes.BACKGROUND,
    ...TraitTypeAndColor.LEGENDARY
  },

  CommonBody: {
    traitType: TraitTypes.CLOTHES,
    ...TraitTypeAndColor.COMMON
  },
  RareBody: {
    traitType: TraitTypes.CLOTHES,
    percent: '2.7',
    ...TraitTypeAndColor.RARE
  },
  SuperRareBody: {
    traitType: TraitTypes.CLOTHES,
    percent: '1.9',
    ...TraitTypeAndColor.SUPER_RARE
  },
  LegendaryBody: {
    traitType: TraitTypes.CLOTHES,
    ...TraitTypeAndColor.LEGENDARY
  },

  CommonFace: {
    traitType: TraitTypes.FACE,
    ...TraitTypeAndColor.COMMON
  },
  RareFace: {
    traitType: TraitTypes.FACE,
    percent: '8.4',
    ...TraitTypeAndColor.RARE
  },
  SuperRareFace: {
    traitType: TraitTypes.FACE,
    ...TraitTypeAndColor.SUPER_RARE
  },
  LegendaryFace: {
    traitType: TraitTypes.FACE,
    ...TraitTypeAndColor.LEGENDARY
  },

  CommonHats: {
    traitType: TraitTypes.HATS,
    ...TraitTypeAndColor.COMMON
  },
  RareHats: {
    traitType: TraitTypes.HATS,
    ...TraitTypeAndColor.RARE
  },
  SuperRareHats: {
    traitType: TraitTypes.HATS,
    ...TraitTypeAndColor.SUPER_RARE
  },
  LegendaryHats: {
    traitType: TraitTypes.HATS,
    percent: '0.8',
    ...TraitTypeAndColor.LEGENDARY
  },

  CommonSkin: {
    traitType: TraitTypes.SKIN,
    ...TraitTypeAndColor.COMMON
  },
  RareSkin: {
    traitType: TraitTypes.SKIN,
    ...TraitTypeAndColor.RARE
  },
  SuperRareSkin: {
    traitType: TraitTypes.SKIN,
    ...TraitTypeAndColor.SUPER_RARE
  },
  LegendarySkin: {
    traitType: TraitTypes.SKIN,
    ...TraitTypeAndColor.LEGENDARY
  }
}

export const RarityData = [
  //backgrounds
  { ...SameTraitProps.CommonBackgrounds, value: 'Beige' },
  { ...SameTraitProps.CommonBackgrounds, value: 'Blue' },
  { ...SameTraitProps.CommonBackgrounds, value: 'Brown' },
  { ...SameTraitProps.CommonBackgrounds, value: 'Green' },
  { ...SameTraitProps.CommonBackgrounds, value: 'Orange' },
  { ...SameTraitProps.CommonBackgrounds, value: 'Red' },
  { ...SameTraitProps.CommonBackgrounds, value: 'Yellow' },
  { ...SameTraitProps.RareBackgrounds, value: 'Pink' },
  { ...SameTraitProps.RareBackgrounds, value: 'Snow' },
  { ...SameTraitProps.RareBackgrounds, value: 'White' },
  { ...SameTraitProps.SuperRareBackgrounds, value: 'Fir christmas' },
  { ...SameTraitProps.SuperRareBackgrounds, value: 'Iceberg' },
  { ...SameTraitProps.SuperRareBackgrounds, value: 'Igloo' },
  { ...SameTraitProps.SuperRareBackgrounds, value: 'Icy mountain' },
  { ...SameTraitProps.LegendaryBackgrounds, value: 'Desert', percent: '0.4' },
  { ...SameTraitProps.LegendaryBackgrounds, value: 'Dracula land', percent: '0.4' },
  { ...SameTraitProps.LegendaryBackgrounds, value: 'Gold', percent: '1.2' },
  { ...SameTraitProps.LegendaryBackgrounds, value: 'Pirate', percent: '0.4' },
  //body
  { ...SameTraitProps.CommonBody, value: 'Black suit', percent: '4.2' },
  { ...SameTraitProps.CommonBody, value: 'Blue hawaiian shirt', percent: '3.8' },
  { ...SameTraitProps.CommonBody, value: 'Sweat shirt christmas blue', percent: '4.2' },
  { ...SameTraitProps.CommonBody, value: 'Sweat shirt christmas red', percent: '4.2' },
  { ...SameTraitProps.CommonBody, value: 'Green hawaiian shirt', percent: '3.8' },
  { ...SameTraitProps.CommonBody, value: 'Pink puffy jacket', percent: '4' },
  { ...SameTraitProps.CommonBody, value: 'Scarf avax', percent: '4.6' },
  { ...SameTraitProps.CommonBody, value: 'Ski suit blue', percent: '4.6' },
  { ...SameTraitProps.CommonBody, value: 'Ski suit red', percent: '4.6' },
  { ...SameTraitProps.CommonBody, value: 'Sweat shirt blue', percent: '4.6' },
  { ...SameTraitProps.CommonBody, value: 'Sweat shirt green', percent: '4.6' },
  { ...SameTraitProps.CommonBody, value: 'Turtle neck', percent: '4.6' },
  { ...SameTraitProps.CommonBody, value: 'Yellow hawaiian shirt', percent: '3.8' },
  { ...SameTraitProps.CommonBody, value: 'Yellow puffy jacket', percent: '4' },
  { ...SameTraitProps.RareBody, value: 'Rich body' },
  { ...SameTraitProps.RareBody, value: 'Garland' },
  { ...SameTraitProps.RareBody, value: 'Lifejacket' },
  { ...SameTraitProps.RareBody, value: 'Pink Kimono' },
  { ...SameTraitProps.RareBody, value: 'Santa suit' },
  { ...SameTraitProps.RareBody, value: 'Sweat shirt avax' },
  { ...SameTraitProps.RareBody, value: 'Tshirt husky' },
  { ...SameTraitProps.RareBody, value: 'Tshirt pangolin' },
  { ...SameTraitProps.RareBody, value: 'Tshirt shiba' },
  { ...SameTraitProps.RareBody, value: 'Tshirt spore' },
  { ...SameTraitProps.RareBody, value: 'Yellow Kimono' },
  { ...SameTraitProps.SuperRareBody, value: 'Baguette under arm' },
  { ...SameTraitProps.SuperRareBody, value: 'Black leather jacket' },
  { ...SameTraitProps.SuperRareBody, value: 'Green leather jacket' },
  { ...SameTraitProps.SuperRareBody, value: 'Hoodie avax' },
  { ...SameTraitProps.SuperRareBody, value: 'Nude' },
  { ...SameTraitProps.LegendaryBody, value: 'Toga', percent: '0.5' },
  { ...SameTraitProps.LegendaryBody, value: 'Pirate t shirt', percent: '0.4' },
  { ...SameTraitProps.LegendaryBody, value: 'Zombie', percent: '0.1' },
  { ...SameTraitProps.LegendaryBody, value: 'Mummy', percent: '0.1' },
  { ...SameTraitProps.LegendaryBody, value: 'Squelette', percent: '0.1' },
  //face
  { ...SameTraitProps.CommonFace, value: 'Glasses', percent: '13' },
  { ...SameTraitProps.CommonFace, value: 'Normal', percent: '18' },
  { ...SameTraitProps.CommonFace, value: 'Ski goggles', percent: '13' },
  { ...SameTraitProps.CommonFace, value: 'Sunglasses', percent: '13' },
  { ...SameTraitProps.RareFace, value: 'Angry' },
  { ...SameTraitProps.RareFace, value: 'Blush' },
  { ...SameTraitProps.RareFace, value: 'Happy' },
  { ...SameTraitProps.RareFace, value: 'Moustache' },
  { ...SameTraitProps.SuperRareFace, value: 'Laser bitcoin', percent: '2.4' },
  { ...SameTraitProps.SuperRareFace, value: 'Cucumber', percent: '2.6' },
  { ...SameTraitProps.SuperRareFace, value: 'Sunglasses avax', percent: '2.4' },
  { ...SameTraitProps.LegendaryFace, value: 'Cyborg eye', percent: '2' },
  //hats
  { ...SameTraitProps.CommonHats, value: 'Arrow', percent: '4' },
  { ...SameTraitProps.CommonHats, value: 'Blue beanie', percent: '4.4' },
  { ...SameTraitProps.CommonHats, value: 'Blue beret', percent: '4' },
  { ...SameTraitProps.CommonHats, value: 'Cowboy hat', percent: '4' },
  { ...SameTraitProps.CommonHats, value: 'Green beret', percent: '4' },
  { ...SameTraitProps.CommonHats, value: 'Grey beret', percent: '4' },
  { ...SameTraitProps.CommonHats, value: 'Headphones', percent: '4' },
  { ...SameTraitProps.CommonHats, value: 'Red beanie', percent: '4.4' },
  { ...SameTraitProps.CommonHats, value: 'Santa beanie', percent: '4.4' },
  { ...SameTraitProps.CommonHats, value: 'Ski helmet', percent: '4.4' },
  { ...SameTraitProps.CommonHats, value: 'Top hat', percent: '4.4' },
  { ...SameTraitProps.CommonHats, value: 'Witch hat', percent: '4.4' },
  { ...SameTraitProps.RareHats, value: 'Beanie avax', percent: '2.6' },
  { ...SameTraitProps.RareHats, value: 'Beanie husky', percent: '2.6' },
  { ...SameTraitProps.RareHats, value: 'Beanie pangolin', percent: '2.6' },
  { ...SameTraitProps.RareHats, value: 'Beanie shiba', percent: '2.6' },
  { ...SameTraitProps.RareHats, value: 'Bear beanie', percent: '3' },
  { ...SameTraitProps.RareHats, value: 'Fried egg', percent: '3' },
  { ...SameTraitProps.RareHats, value: 'Mushroom Hat', percent: '3' },
  { ...SameTraitProps.RareHats, value: 'Penguin beanie', percent: '3' },
  { ...SameTraitProps.RareHats, value: 'Rice hat', percent: '3' },
  { ...SameTraitProps.RareHats, value: 'Roman helmet', percent: '3' },
  { ...SameTraitProps.SuperRareHats, value: 'Cap avax', percent: '1.8' },
  { ...SameTraitProps.SuperRareHats, value: 'Fez', percent: '1.8' },
  { ...SameTraitProps.SuperRareHats, value: 'Gold earring', percent: '1.8' },
  { ...SameTraitProps.SuperRareHats, value: 'Indian headdress', percent: '2' },
  { ...SameTraitProps.SuperRareHats, value: 'King crown', percent: '1.8' },
  { ...SameTraitProps.SuperRareHats, value: 'Pink earring', percent: '1.8' },
  { ...SameTraitProps.SuperRareHats, value: 'Ruby earring', percent: '1.8' },
  { ...SameTraitProps.SuperRareHats, value: 'Sapphire earring', percent: '1.8' },
  { ...SameTraitProps.SuperRareHats, value: 'Super Tubby', percent: '1.8' },
  { ...SameTraitProps.SuperRareHats, value: 'Toucan', percent: '1.8' },
  { ...SameTraitProps.SuperRareHats, value: 'Ushanka', percent: '1.8' },
  { ...SameTraitProps.LegendaryHats, value: 'Dragon' },
  { ...SameTraitProps.LegendaryHats, value: 'Flaming horn' },
  { ...SameTraitProps.LegendaryHats, value: 'Space helmet' },
  //skin
  { ...SameTraitProps.CommonSkin, value: 'Light pink', percent: '13.9' },
  { ...SameTraitProps.CommonSkin, value: 'Normal', percent: '14.5' },
  { ...SameTraitProps.CommonSkin, value: 'Olive', percent: '13.86' },
  { ...SameTraitProps.CommonSkin, value: 'Red', percent: '14.3' },
  { ...SameTraitProps.CommonSkin, value: 'Ice', percent: '14.04' },
  { ...SameTraitProps.RareSkin, value: 'Dark', percent: '5.66' },
  { ...SameTraitProps.RareSkin, value: 'Orange', percent: '6.18' },
  { ...SameTraitProps.SuperRareSkin, value: 'Black', percent: '3.76' },
  { ...SameTraitProps.SuperRareSkin, value: 'Tiger', percent: '4.04' },
  { ...SameTraitProps.SuperRareSkin, value: 'White', percent: '3.78' },
  { ...SameTraitProps.LegendarySkin, value: 'Gold', percent: '2.2' },
  { ...SameTraitProps.LegendarySkin, value: 'Light grey', percent: '3.74' }
]